import SaleAdmin from '../views/saleService/SaleAdmin'
import SaleDesc from '../views/saleService/SaleDesc'
const routers = [
  {
    path: '/saleAdmin',
    name: 'SaleAmin',
    component: SaleAdmin
  },
  {
    path: '/saleAdmin/saleDesc/:id',
    name: 'SaleDesc',
    component: SaleDesc
  }
];
export default routers;


// WEBPACK FOOTER //
// ./src/routers/saleService.js